(() => {
  const styleId = 'dominator-control-cleanup-runtime';
  const css = `
    .site-header,
    .site-header:not(.is-scrolled) {
      background: #050506 !important;
      background-color: #050506 !important;
      color: #fff !important;
      border-bottom: 1px solid rgba(255, 255, 255, 0.14) !important;
      box-shadow: 0 10px 26px rgba(0, 0, 0, 0.26) !important;
      backdrop-filter: none !important;
    }

    .site-header.is-scrolled {
      background: #050506 !important;
      background-color: #050506 !important;
      color: #fff !important;
      border-bottom: 1px solid rgba(255, 255, 255, 0.14) !important;
      box-shadow: 0 10px 26px rgba(0, 0, 0, 0.26) !important;
      backdrop-filter: none !important;
    }

    .site-header .announcement-bar {
      background: #07101e !important;
      color: #fff !important;
    }

    .site-header .brand,
    .site-header .brand-logo,
    .site-header .site-nav a,
    .site-header .site-nav button,
    .site-header .cart-link,
    .site-header .menu-button,
    .template-product .site-header .product-switch,
    .template-product .site-header .product-switch a,
    .template-product .site-header .product-switch span {
      color: #fff !important;
    }

    .template-product .site-header.is-scrolled .site-header__inner {
      min-height: 40px !important;
      height: 40px !important;
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }

    .template-product .site-header.is-scrolled .brand-logo {
      width: 150px !important;
    }

    .template-product .site-header.is-scrolled .site-header__actions .button,
    .template-product .site-header.is-scrolled .cart-link {
      min-height: 32px !important;
      height: 32px !important;
    }

    .template-product .pdp-anchor-nav {
      top: var(--sticky-header-offset, 40px) !important;
      height: 18px !important;
      min-height: 18px !important;
      max-height: 18px !important;
      padding: 0 max(10px, calc((100vw - 1240px) / 2 + 10px)) !important;
      border-top: 0 !important;
      border-bottom: 1px solid rgba(255,255,255,.14) !important;
      background: #050506 !important;
      box-shadow: none !important;
      overflow: hidden !important;
      align-items: center !important;
      box-sizing: border-box !important;
    }

    .template-product .pdp-anchor-nav a {
      height: 16px !important;
      min-height: 16px !important;
      max-height: 16px !important;
      padding: 0 8px !important;
      border-color: rgba(13,20,36,.16) !important;
      border-radius: 3px !important;
      background: rgba(255,255,255,.96) !important;
      color: #0d1424 !important;
      font-size: 8px !important;
      font-weight: 900 !important;
      line-height: 1 !important;
      letter-spacing: 0 !important;
      white-space: nowrap !important;
      box-sizing: border-box !important;
    }

    .template-product .pdp-anchor-nav a.is-active,
    .template-product .pdp-anchor-nav a[aria-current="true"] {
      background: #006cff !important;
      border-color: #006cff !important;
      color: #fff !important;
      box-shadow: none !important;
    }

    @media (max-width: 720px) {
      .site-header .menu-button,
      .template-product .menu-button {
        display: none !important;
      }

      .template-product .site-header.is-scrolled .site-header__inner {
        min-height: 46px !important;
        height: 46px !important;
        grid-template-columns: minmax(0, 1fr) auto !important;
        padding-left: 18px !important;
        padding-right: 18px !important;
      }

      .template-product .pdp-anchor-nav {
        top: var(--sticky-header-offset, 46px) !important;
        height: 21px !important;
        min-height: 21px !important;
        max-height: 21px !important;
        grid-auto-columns: minmax(82px, 1fr) !important;
        gap: 4px !important;
        padding: 0 8px !important;
        border-bottom-width: 0 !important;
        overflow-x: auto !important;
        overflow-y: hidden !important;
        scrollbar-width: none !important;
      }

      .template-product .pdp-anchor-nav::-webkit-scrollbar {
        display: none !important;
      }

      .template-product .pdp-anchor-nav a {
        height: 18px !important;
        min-height: 18px !important;
        max-height: 18px !important;
        padding: 0 6px !important;
        font-size: 8px !important;
      }

      body.template-product:not(.support-open):not(.template-cart) .thumb-nav {
        display: block !important;
        visibility: visible !important;
        opacity: 1 !important;
        pointer-events: auto !important;
        position: fixed !important;
        right: 12px !important;
        bottom: calc(14px + env(safe-area-inset-bottom)) !important;
        width: 64px !important;
        height: 64px !important;
        min-height: 64px !important;
        z-index: 72 !important;
      }

      body.template-product:not(.support-open):not(.template-cart) .thumb-nav--pdp {
        bottom: calc(14px + env(safe-area-inset-bottom)) !important;
      }

      body.template-product.has-sticky-cart-visible:not(.support-open):not(.template-cart) .thumb-nav--pdp {
        bottom: calc(92px + env(safe-area-inset-bottom)) !important;
      }

      body.template-product:not(.support-open):not(.template-cart) .thumb-nav__main {
        display: grid !important;
        width: 64px !important;
        height: 64px !important;
        min-height: 64px !important;
        border: 2px solid rgba(255,255,255,.94) !important;
        background: #0d1424 !important;
        color: #fff !important;
      }

      body.support-open .thumb-nav,
      .support-drawer:not([hidden]) ~ .thumb-nav {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        pointer-events: none !important;
      }
    }

      /* 2026-06-16 PDP sticky stack cleanup: runtime guard for cached PDP pages. */
      .template-product .site-header.is-scrolled {
        background: #050506 !important;
        background-color: #050506 !important;
        color: #fff !important;
      }
      .template-product .site-header.is-scrolled .site-header__inner {
        min-height: 42px !important;
        height: 42px !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
      }
      .template-product .pdp-anchor-nav {
        top: var(--sticky-header-offset, 42px) !important;
        height: 20px !important;
        min-height: 20px !important;
        max-height: 20px !important;
        align-items: center !important;
        border-top: 0 !important;
        border-bottom: 1px solid rgba(255,255,255,.14) !important;
        background: #050506 !important;
        box-shadow: none !important;
        overflow-y: hidden !important;
      }
      .template-product .pdp-anchor-nav a {
        height: 18px !important;
        min-height: 18px !important;
        max-height: 18px !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        border-radius: 3px !important;
        line-height: 1 !important;
      }
      .template-product .pdp-anchor-nav a.is-active,
      .template-product .pdp-anchor-nav a[aria-current="true"] {
        border-color: #006cff !important;
        background: #006cff !important;
        color: #fff !important;
        box-shadow: none !important;
      }
      @media (max-width: 720px) {
        .template-product .site-header.is-scrolled .site-header__inner {
          min-height: 42px !important;
          height: 42px !important;
          padding-left: 18px !important;
          padding-right: 18px !important;
        }
        .template-product .pdp-anchor-nav {
          top: var(--sticky-header-offset, 42px) !important;
          height: 20px !important;
          min-height: 20px !important;
          max-height: 20px !important;
          grid-auto-columns: minmax(78px, 1fr) !important;
          padding-left: 8px !important;
          padding-right: 8px !important;
          overflow-x: auto !important;
          scrollbar-width: none !important;
        }
        .template-product .pdp-anchor-nav::-webkit-scrollbar { display: none !important; }
        .template-product .pdp-anchor-nav a {
          height: 18px !important;
          min-height: 18px !important;
          max-height: 18px !important;
          padding-left: 6px !important;
          padding-right: 6px !important;
          font-size: 8px !important;
        }
      }
  `;

  const upsertStyle = () => {
    let style = document.getElementById(styleId);
    if (!style) {
      style = document.createElement('style');
      style.id = styleId;
      document.head.appendChild(style);
    }
    style.textContent = css;
  };

  const syncOffsets = () => {
    const header = document.querySelector('[data-site-header]');
    const inner = header?.querySelector('.site-header__inner');
    if (!header) return;
    const fullHeight = Math.ceil(header.getBoundingClientRect().height);
    const compactHeight = Math.ceil((inner || header).getBoundingClientRect().height);
    document.documentElement.style.setProperty('--site-header-offset', `${fullHeight}px`);
    document.documentElement.style.setProperty('--sticky-header-offset', `${compactHeight}px`);
  };

  upsertStyle();
  requestAnimationFrame(syncOffsets);
  window.addEventListener('scroll', () => requestAnimationFrame(syncOffsets), { passive: true });
  window.addEventListener('resize', () => requestAnimationFrame(syncOffsets));

  const $ = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  const supportDrawer = document.querySelector('[data-support-drawer]');
  const syncSupportState = () => {
    const supportOpen = Boolean(supportDrawer && !supportDrawer.hidden);
    document.body.classList.toggle('support-open', supportOpen);
    if (supportOpen) document.querySelector('[data-thumb-nav]')?.classList.remove('is-open');
  };

  if (supportDrawer) {
    syncSupportState();
    new MutationObserver(syncSupportState).observe(supportDrawer, { attributes: true, attributeFilter: ['hidden'] });
    document.addEventListener('click', (event) => {
      if (event.target instanceof Element && event.target.closest('[data-support-open], [data-support-close]')) {
        requestAnimationFrame(syncSupportState);
        setTimeout(syncSupportState, 60);
      }
    }, true);
  }

  const variantData = (() => {
    try {
      return JSON.parse(document.querySelector('[data-product-variant-data]')?.textContent || '{}').variants || [];
    } catch (error) {
      return [];
    }
  })();

  const finishImageFallbacks = {
    'dominator-72-inch-basketball-hoop': {
      black: 'https://cdn.shopify.com/s/files/1/0761/2107/9996/files/72_BlackBasketballHoop8.png',
      brushed: 'https://cdn.shopify.com/s/files/1/0761/2107/9996/files/0000.png'
    },
    'dominator-60-inch-basketball-hoop': {
      black: 'https://cdn.shopify.com/s/files/1/0761/2107/9996/files/Black-60.jpg',
      brushed: 'https://cdn.shopify.com/s/files/1/0761/2107/9996/files/60xl-Glorify.png'
    },
    'dominator-54-basketball-hoop': {
      black: 'https://cdn.shopify.com/s/files/1/0761/2107/9996/files/Black-54-1.jpg',
      brushed: 'https://cdn.shopify.com/s/files/1/0761/2107/9996/files/542-AA-Main.png'
    },
    'dominator-pro-72-basketball-hoop-shatterproof-aluminum-backboard': {
      black: 'https://cdn.shopify.com/s/files/1/0761/2107/9996/files/Perf-Woo-black.jpg',
      brushed: 'https://cdn.shopify.com/s/files/1/0761/2107/9996/files/Perf-Woo.jpg'
    }
  };

  const selectedOptions = () => $('[data-option-select]').map((select) => select.value);
  const selectedVariant = () => {
    if (!variantData.length) return null;
    const options = selectedOptions();
    return variantData.find((variant) => options.every((value, index) => variant.options?.[index] === value)) || variantData[0] || null;
  };
  const productRoot = document.querySelector('[data-product-root]');
  const productHandle = () => productRoot?.dataset.productHandle || '';
  const productTitle = () => document.querySelector('h1')?.textContent?.trim() || productHandle() || 'Dominator product';
  const imageForFinish = (variant, finish) => {
    if (variant?.featuredImage) return variant.featuredImage;
    const key = /black/i.test(finish) ? 'black' : /brushed|silver|aluminum/i.test(finish) ? 'brushed' : '';
    return key ? finishImageFallbacks[productHandle()]?.[key] || '' : '';
  };
  const setImage = (image, src, alt) => {
    if (!image) return;
    if (src) {
      image.setAttribute('src', src);
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
    }
    image.setAttribute('alt', alt);
  };
  const ensurePriceNote = () => {
    let note = document.querySelector('[data-product-price-note]');
    if (note) return note;
    const priceRow = document.querySelector('.price-row');
    if (!priceRow) return null;
    note = document.createElement('small');
    note.setAttribute('data-product-price-note', '');
    priceRow.appendChild(note);
    return note;
  };
  const isMeaningfulFinish = (value = '') => {
    const normalized = String(value || '').trim();
    return normalized && !/^default(?:\s+title)?$/i.test(normalized);
  };
  const syncSelectedFinishSurfaces = () => {
    const variant = selectedVariant();
    if (!variant) return;
    const rawFinish = variant.options?.[0] || variant.title || '';
    const finish = isMeaningfulFinish(rawFinish) ? String(rawFinish).trim() : '';
    const title = productTitle();
    const alt = finish ? title + ' ' + finish : title + ' product image';
    const imageSrc = imageForFinish(variant, finish);

    $('[data-product-finish-label]').forEach((node) => {
      node.textContent = document.body.classList.contains('template-product') && finish ? 'Finish shown: ' + finish : 'Product shown';
    });
    const note = finish ? ensurePriceNote() : document.querySelector('[data-product-price-note]');
    if (note) {
      note.textContent = finish ? finish + ' finish price. Other finishes may vary.' : '';
      note.hidden = !finish;
    }
    $('[data-product-preview-image]').forEach((image) => setImage(image, imageSrc, alt));
    $('[data-product-media-main] img').forEach((image) => setImage(image, imageSrc, alt));
    $('[data-product-media-main] [data-media-caption-label]').forEach((node) => {
      node.textContent = finish ? 'Selected finish' : 'Product shown';
    });
    $('[data-product-media-main] [data-media-caption-title]').forEach((node) => {
      node.textContent = finish || title;
    });
  };
  const scheduleFinishSync = () => {
    requestAnimationFrame(syncSelectedFinishSurfaces);
    setTimeout(syncSelectedFinishSurfaces, 80);
  };

  if (variantData.length) {
    $('[data-option-select]').forEach((select) => select.addEventListener('change', scheduleFinishSync));
    $('[data-variant-pill]').forEach((button) => button.addEventListener('click', scheduleFinishSync));
  }

})();

(() => {
  const fallbackMarker = 'dominator-home-tab-fallback-20260616';
  if (window[fallbackMarker]) return;
  window[fallbackMarker] = true;

  const one = (selector, root = document) => root.querySelector(selector);
  const all = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const modeData = {
    hoops: {
      title: 'Build The Driveway They Remember',
      text: 'The hoop is the product. The win is a driveway that becomes the place people keep coming back to.',
      primaryLabel: 'Find your hoop',
      primaryHref: '/products/dominator-72-inch-basketball-hoop#product-decisions',
      buyHref: '/products/dominator-72-inch-basketball-hoop',
      heroImage: 'https://cdn.shopify.com/s/files/1/0761/2107/9996/files/72PI1-scaled.jpg',
      productTitle: '72 Inch',
      productCopy: 'From $2,899',
      productImage: 'https://cdn.shopify.com/s/files/1/0761/2107/9996/files/Untitled-Design-21.png'
    },
    pickleball: {
      title: 'Make Every Rally Match Ready',
      text: 'Real tension, fast setup, and a net system that makes the court feel ready before the first serve.',
      primaryLabel: 'Explore nets',
      primaryHref: '/products/pro-max-rolling-portable-pickleball-net#product-decisions',
      buyHref: '/products/pro-max-rolling-portable-pickleball-net',
      heroImage: 'https://cdn.shopify.com/s/files/1/0761/2107/9996/files/pb-pro-court-1.jpg',
      productTitle: 'Pro Max Rolling Net',
      productCopy: 'From $1,999',
      productImage: 'https://cdn.shopify.com/s/files/1/0761/2107/9996/files/pb-max-primary.jpg'
    },
    lights: {
      title: 'Own The Court After Sunset',
      text: 'One more serve, one more rebound, and one more hour when the work becomes visible.',
      primaryLabel: 'Plan lighting',
      primaryHref: '/products/dominator-150w-led-light#product-decisions',
      buyHref: '/products/dominator-150w-led-light',
      heroImage: 'https://cdn.shopify.com/s/files/1/0761/2107/9996/files/IMG_1698-scaled.jpg',
      productTitle: '150W Wired Light',
      productCopy: 'From $250',
      productImage: 'https://cdn.shopify.com/s/files/1/0761/2107/9996/files/Untitled-Design-16.png'
    }
  };

  const setText = (selector, value, root = document) => {
    const node = one(selector, root);
    if (node && value) node.textContent = value;
  };

  const setImage = (selector, src, alt, root = document) => {
    const image = one(selector, root);
    if (!image || !src) return;
    image.src = src;
    image.alt = alt || '';
  };

  const applyMode = (category) => {
    const data = modeData[category];
    const hero = one('[data-home-hero]');
    if (!hero || !data) return;
    const beforeY = window.scrollY;
    const previousHeight = Math.ceil(hero.getBoundingClientRect().height);
    if (previousHeight) hero.style.minHeight = previousHeight + 'px';

    Object.keys(modeData).forEach((mode) => {
      hero.classList.toggle('hero--' + mode, mode === category);
    });
    setText('[data-home-hero-title]', data.title, hero);
    setText('[data-home-hero-copy]', data.text, hero);
    setText('[data-hero-product-title]', data.productTitle, hero);
    setText('[data-hero-product-copy]', data.productCopy, hero);
    setImage('[data-home-hero-image]', data.heroImage, data.title, hero);
    setImage('[data-hero-product-image]', data.productImage, data.productTitle, hero);

    const primary = one('[data-home-hero-primary]', hero);
    if (primary) {
      primary.textContent = data.primaryLabel;
      primary.href = data.primaryHref;
    }
    const buy = one('[data-home-hero-buy]', hero);
    if (buy) buy.href = data.buyHref;

    requestAnimationFrame(() => {
      hero.style.minHeight = '';
      if (Math.abs(window.scrollY - beforeY) > 1) window.scrollTo({ top: beforeY, left: window.scrollX });
    });
  };

  const reorderProductRunway = (category) => {
    const runway = one('[data-home-system-showcases]');
    if (!runway) return;
    const groups = {
      hoops: ['hoops', 'hoop-picker'],
      pickleball: ['pickleball', 'net-picker'],
      lights: ['lights', 'light-picker']
    };
    const preferred = groups[category] || groups.hoops;
    const orderedIds = [
      ...preferred,
      ...Object.entries(groups)
        .filter(([key]) => key !== category)
        .flatMap(([, ids]) => ids)
    ];
    const heading = one(':scope > .section-heading', runway);
    let anchor = heading ? heading.nextSibling : runway.firstChild;
    const beforeY = window.scrollY;
    orderedIds.map((id) => document.getElementById(id)).filter(Boolean).forEach((section) => {
      runway.insertBefore(section, anchor);
      anchor = section.nextSibling;
    });
    if (Math.abs(window.scrollY - beforeY) > 1) window.scrollTo({ top: beforeY, left: window.scrollX });
  };

  const bindHomeTabs = () => {
    if (window.DominatorTheme?.homeTabsReady) return;
    const tabs = all('[data-category-tab]');
    if (!tabs.length) return;
    tabs.forEach((tab) => {
      if (tab.dataset.dominatorHomeTabBound === 'true') return;
      tab.dataset.dominatorHomeTabBound = 'true';
      tab.addEventListener('click', (event) => {
        event.preventDefault();
        const category = tab.dataset.categoryTab || 'hoops';
        tabs.forEach((candidate) => {
          const selected = candidate === tab;
          candidate.classList.toggle('is-active', selected);
          candidate.classList.toggle('selected', selected);
          candidate.setAttribute('aria-selected', selected ? 'true' : 'false');
        });
        applyMode(category);
        reorderProductRunway(category);
      });
    });
  };

  const bindCompareButtons = () => {
    if (window.DominatorTheme?.compareBindingsReady) return;
    all('[data-compare-expand]').forEach((button) => {
      if (button.dataset.dominatorCompareBound === 'true') return;
      button.dataset.dominatorCompareBound = 'true';
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const card = button.closest('.comparison-card') || button.parentElement || document;
        const details = one('[data-compare-details]', card);
        if (!details) return;
        details.hidden = !details.hidden;
        all('[data-compare-extra]', card).forEach((row) => {
          row.hidden = details.hidden;
        });
        button.textContent = details.hidden ? 'See all detailed specs' : 'Hide all detailed specs';
      });
    });
  };

  const boot = () => {
    bindHomeTabs();
    bindCompareButtons();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  window.addEventListener('pageshow', boot);
})();

(() => {
  const marker = 'dominator-resilient-interaction-fallback-20260616';
  if (window[marker]) return;
  window[marker] = true;

  const one = (selector, root = document) => root.querySelector(selector);
  const all = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  window.DominatorTheme = window.DominatorTheme || {};

  const supportModes = {
    buying: ['Ask Before Buying', 'Compare products, dimensions, install timing, and fit before checkout.'],
    contact: ['Contact Dominator', 'Tell our team what you need help with.'],
    planner: ['Court Planning', 'Share court dimensions, product ideas, and planning questions.'],
    installer: ['Installer Help', 'Send the zip and project type so Dominator can route the right next step.'],
    parts: ['Parts And Accessories', 'Ask for replacement parts, padding, accessories, or SKU help.'],
    support: ['Support Or Warranty', 'Tell us your product, order number, and what needs attention.']
  };

  const safeOpenSupport = (intent = 'buying', query = '') => {
    const drawer = one('[data-support-drawer]');
    if (!drawer) return;
    drawer.hidden = false;
    const mode = supportModes[intent] || supportModes.buying;
    const setValue = (selector, value) => {
      const field = one(selector, drawer);
      if (field) field.value = value;
    };
    const title = one('[data-support-title]', drawer);
    const copy = one('[data-support-mode-copy]', drawer);
    if (title) title.textContent = mode[0];
    if (copy) copy.textContent = mode[1];
    setValue('[name="intent"]', intent);
    if (query) setValue('[name="question"]', query);
    setValue('[name="product"]', one('[data-product-root] h1')?.textContent?.trim() || one('[data-product-root]')?.dataset.productHandle || '');
    setValue('[name="source_url"]', window.location.href);
    setValue('[name="cart_token"]', window.DominatorTheme?.cartToken || '');
    setValue('[name="planner_context"]', window.DominatorPlanner?.currentPlan || '');
    document.body.classList.add('support-open');
    one('[data-thumb-nav]')?.classList.remove('is-open');
  };

  const safeCloseSupport = () => {
    const drawer = one('[data-support-drawer]');
    if (drawer) drawer.hidden = true;
    document.body.classList.remove('support-open');
  };

  const bindSupportFallback = () => {
    window.DominatorTheme.openSupport = safeOpenSupport;
    all('[data-support-open]').forEach((button) => {
      if (button.dataset.dominatorSupportFallbackBound === 'true') return;
      button.dataset.dominatorSupportFallbackBound = 'true';
      button.addEventListener('click', () => safeOpenSupport(button.dataset.supportIntent || 'buying', button.dataset.supportQuery || ''));
    });
    all('[data-support-close]').forEach((button) => {
      if (button.dataset.dominatorSupportCloseFallbackBound === 'true') return;
      button.dataset.dominatorSupportCloseFallbackBound = 'true';
      button.addEventListener('click', safeCloseSupport);
    });
  };

  const bindThumbFallback = () => {
    if (window.DominatorTheme.thumbNavReady) return;
    const nav = one('[data-thumb-nav]');
    const toggle = one('[data-thumb-toggle]', nav || document);
    const label = one('[data-thumb-toggle-label]', nav || document);
    if (!nav || !toggle) return;
    const groups = ['products', 'explore', 'resources'];
    const setGroup = (group = '') => {
      groups.forEach((candidate) => nav.classList.toggle('thumb-nav--' + candidate + '-open', candidate === group));
      all('[data-thumb-group]', nav).forEach((button) => button.classList.toggle('selected', button.dataset.thumbGroup === group));
      all('[data-thumb-children]', nav).forEach((children) => {
        children.hidden = children.dataset.thumbChildren !== group;
      });
    };
    const setOpen = (open) => {
      nav.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      if (label) label.textContent = open ? 'Close' : 'Nav';
      if (!open) setGroup('');
    };
    if (toggle.dataset.dominatorThumbFallbackBound !== 'true') {
      toggle.dataset.dominatorThumbFallbackBound = 'true';
      toggle.addEventListener('click', () => setOpen(!nav.classList.contains('is-open')));
    }
    all('[data-thumb-group]', nav).forEach((button) => {
      if (button.dataset.dominatorThumbGroupFallbackBound === 'true') return;
      button.dataset.dominatorThumbGroupFallbackBound = 'true';
      button.addEventListener('click', () => {
        const group = button.dataset.thumbGroup || '';
        const alreadyOpen = nav.classList.contains('thumb-nav--' + group + '-open');
        setOpen(true);
        setGroup(alreadyOpen ? '' : group);
      });
    });
    all('.thumb-nav a, .thumb-nav [data-support-open]').forEach((item) => {
      if (item.dataset.dominatorThumbCloseFallbackBound === 'true') return;
      item.dataset.dominatorThumbCloseFallbackBound = 'true';
      item.addEventListener('click', () => setOpen(false));
    });
    setGroup('');
  };

  const parseVariantData = () => {
    try {
      return JSON.parse(one('[data-product-variant-data]')?.textContent || '{}').variants || [];
    } catch {
      return [];
    }
  };

  const bindVariantFallback = () => {
    if (window.DominatorTheme.variantBindingsReady) return;
    const variants = parseVariantData();
    if (!variants.length) return;
    const selectedOptions = () => all('[data-option-select]').map((select) => select.value);
    const selectedVariant = () => {
      const options = selectedOptions();
      return variants.find((variant) => options.every((value, index) => variant.options?.[index] === value)) || variants[0] || null;
    };
    const sync = () => {
      const variant = selectedVariant();
      if (!variant) return;
      const rawFinish = variant.options?.[0] || variant.title || '';
      const finish = isMeaningfulFinish(rawFinish) ? String(rawFinish).trim() : '';
      const title = one('h1')?.textContent.trim() || 'Dominator product';
      const alt = finish ? title + ' ' + finish : title + ' product image';
      all('[data-variant-id-input], [data-sticky-variant-id]').forEach((input) => { input.value = variant.id; });
      all('[data-product-price]').forEach((node) => { node.textContent = variant.formattedPrice || node.textContent; });
      all('[data-sticky-price]').forEach((node) => { node.textContent = (variant.formattedPrice || '') + ' • ' + (node.dataset.shippingMessage || 'Free shipping in the contiguous U.S.'); });
      all('[data-product-finance]').forEach((node) => { node.textContent = variant.formattedFinance || ''; });
      all('[data-variant-pill]').forEach((button) => {
        const position = Number(button.dataset.optionPosition || 0);
        button.classList.toggle('is-active', selectedOptions()[position] === button.dataset.optionValue);
      });
      all('[data-product-finish-label]').forEach((node) => { node.textContent = finish ? 'Finish shown: ' + finish : 'Product shown'; });
      let note = one('[data-product-price-note]');
      const priceRow = one('.price-row');
      if (!note && priceRow && finish) {
        note = document.createElement('small');
        note.setAttribute('data-product-price-note', '');
        priceRow.appendChild(note);
      }
      if (note) {
        note.textContent = finish ? finish + ' finish price. Other finishes may vary.' : '';
        note.hidden = !finish;
      }
      if (variant.featuredImage) {
        all('[data-product-preview-image], [data-product-media-main] img').forEach((image) => {
          image.src = variant.featuredImage;
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.alt = alt;
        });
      }
      all('[data-product-media-main] [data-media-caption-label]').forEach((node) => { node.textContent = finish ? 'Selected finish' : 'Product shown'; });
      all('[data-product-media-main] [data-media-caption-title]').forEach((node) => { node.textContent = finish || title; });
    };
    all('[data-option-select]').forEach((select) => {
      if (select.dataset.dominatorVariantFallbackBound === 'true') return;
      select.dataset.dominatorVariantFallbackBound = 'true';
      select.addEventListener('change', sync);
    });
    all('[data-variant-pill]').forEach((button) => {
      if (button.dataset.dominatorVariantPillFallbackBound === 'true') return;
      button.dataset.dominatorVariantPillFallbackBound = 'true';
      button.addEventListener('click', () => {
        const select = one('[data-option-select][data-option-position="' + (button.dataset.optionPosition || '0') + '"]');
        if (select) {
          select.value = button.dataset.optionValue || select.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        requestAnimationFrame(sync);
      });
    });
    // Do not sync on first paint; initial Liquid media is the parity baseline.
  };

  const boot = () => {
    bindSupportFallback();
    bindThumbFallback();
    bindVariantFallback();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  window.addEventListener('pageshow', boot);
})();



(() => {
  const styleId = 'dominator-visual-polish-runtime-20260616';
  const css = `
    .template-product .pdp-anchor-nav {
      height: 36px !important;
      min-height: 36px !important;
      max-height: 36px !important;
      gap: 8px !important;
      padding-top: 3px !important;
      padding-bottom: 3px !important;
      background: #050506 !important;
    }
    .template-product .pdp-anchor-nav a {
      height: 30px !important;
      min-height: 30px !important;
      max-height: 30px !important;
      padding: 0 12px !important;
      border-radius: 5px !important;
      font-size: 10px !important;
    }
    @media (max-width: 720px) {
      .template-product .pdp-anchor-nav {
        height: 32px !important;
        min-height: 32px !important;
        max-height: 32px !important;
        grid-auto-columns: minmax(94px, 1fr) !important;
        gap: 6px !important;
        padding: 2px 8px !important;
      }
      .template-product .pdp-anchor-nav a {
        height: 28px !important;
        min-height: 28px !important;
        max-height: 28px !important;
        padding: 0 8px !important;
        font-size: 9px !important;
      }
    }
  `;
  let style = document.getElementById(styleId);
  if (!style) {
    style = document.createElement('style');
    style.id = styleId;
    document.head.appendChild(style);
  }
  style.textContent = css;
})();

(() => {
  const marker = 'dominator-review-controls-20260616';
  if (window[marker]) return;
  window[marker] = true;
  const all = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const applyFilter = (filter = 'All') => {
    all('[data-review-filter]').forEach((button) => {
      const selected = (button.dataset.reviewFilter || 'All') === filter;
      button.classList.toggle('selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    all('[data-review-item]').forEach((item) => {
      const tag = item.dataset.reviewTag || '';
      item.hidden = filter !== 'All' && tag !== filter;
    });
  };
  const bind = () => {
    all('[data-review-filter]').forEach((button) => {
      if (button.dataset.dominatorReviewFilterBound === 'true') return;
      button.dataset.dominatorReviewFilterBound = 'true';
      button.addEventListener('click', (event) => {
        event.preventDefault();
        applyFilter(button.dataset.reviewFilter || 'All');
      });
    });
    all('[data-review-show-all]').forEach((button) => {
      if (button.dataset.dominatorReviewShowAllBound === 'true') return;
      button.dataset.dominatorReviewShowAllBound = 'true';
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        applyFilter('All');
        all('[data-review-item]').forEach((item) => { item.hidden = false; });
      }, true);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, { once: true });
  else bind();
  window.addEventListener('pageshow', bind);
})();
